<template>
    <v-container fluid style="background-color: #333233;">
        <copyright />
    </v-container>
</template>

<script>
    import Copyright from "./Copyright";

    export default {
        name: 'Footer',
        props: ['isCheckout'],
        components: {
            Copyright
        }
    }
</script>
